var VARIANTSKU = [

    // *** CHAIN LINK FENCE PARTS LIST ***
    
    {
"9AF60X72FT-PPF" : "53733722784054",
"AFS-FULLYARD-4-OI-FTPP-75" : "53733722816822",
"AFS-FULLYARD-4-OI-FTPP-100" : "53733722882358",
"AFS-FULLYARD-4-OI-FTPP-150" : "53733722947894",
"AFS-FULLYARD-4-OI-FTPP-200" : "53733722980662",
"AFS-FULLYARD-4-OI-FTPP-250" : "53733723013430",
"AFS-FULLYARD-4-OI-FTPP-300" : "53733723046198",
"AFS-FULLYARD-4-OI-FTPP-350" : "53733723111734",
"AFS-FULLYARD-6-OI-FTPP-50" : "53733723177270",
"AFS-FULLYARD-6-OI-FTPP-75" : "53733723210038",
"AFS-FULLYARD-6-OI-FTPP-100" : "53733723308342",
"AFS-FULLYARD-6-OI-FTPP-150" : "53733723341110",
"AFS-FULLYARD-6-OI-FTPP-200" : "53733723406646",
"AFS-FULLYARD-6-OI-FTPP-250" : "53733723472182",
"AFS-FULLYARD-6-OI-FTPP-300" : "53733723504950",
"AFS-FULLYARD-6-OI-FTPP-350" : "53733723537718",
"10844" : "53733723570486",
"10844-PPB" : "53733723603254",
"8P4028800" : "53733723636022",
"8P4028800-PPB" : "53733728747830",
"8W12P288" : "53733723668790",
"8W12P288-PPB" : "53733723701558",
"8W12P108" : "53733723734326",
"8W12P108-PPB" : "53733723767094",
"10843" : "53733723799862",
"10843-PPB" : "53733723832630",
"CFP-Corner-Post-Kit-4-OI-ST" : "48946840568118",
"CFP-Corner-Post-Kit-5-OI-ST" : "49344236781878",
"CFP-Corner-Post-Kit-6-OI-ST" : "49344236814646",
"CFP-End-Post-Kit-4-OI-ST" : "48946840600886",
"CFP-End-Post-Kit-5-OI-ST" : "49344236519734",
"CFP-End-Post-Kit-6-OI-ST" : "49344236552502",
"CFP-Gate-Kit-4x4-OI-ST" : "48946840666422",
"CFP-Gate-Kit-4x5-OI-ST" : "49344236257590",
"CFP-Gate-Kit-4x6-OI-ST" : "49344236355894",
"CFP-End-Post-Kit-4-OI-FT" : "48946841420086",
"CFP-End-Post-Kit-5-OI-FT" : "49344236060982",
"CFP-End-Post-Kit-6-OI-FT" : "49344236093750",
"CFP-Corner-Post-Kit-4-OI-FT" : "48946841452854",
"CFP-Corner-Post-Kit-5-OI-FT" : "49344235503926",
"CFP-Corner-Post-Kit-6-OI-FT" : "49344235536694",
"CFP-Gate-Kit-4x4-OI-FT" : "48946841485622",
"CFP-Gate-Kit-4x5-OI-FT" : "49344235372854",
"CFP-Gate-Kit-4x6-OI-FT" : "49344235405622",
"AFC-FULLYARD-AFS-FULLYARD-4-BOA-FT-EXTRA-FEET" : "48946841714998",
"AFC-FULLYARD-AFS-FULLYARD-5-BOA-FT-EXTRA-FEET" : "49344235176246",
"AFC-FULLYARD-AFS-FULLYARD-6-BOA-FT-EXTRA-FEET" : "49344235209014",
"AFC-FULLYARD-AFS-FULLYARD-5-OI-ST-EXTRA-FEET" : "48946841977142",
"AFC-FULLYARD-AFS-FULLYARD-6-OI-ST-EXTRA-FEET" : "49344234979638",
"AFC-FULLYARD-AFS-FULLYARD-4-OI-FT-EXTRA-FEET" : "48946842337590",
"AFC-FULLYARD-AFS-FULLYARD-5-OI-FT-EXTRA-FEET" : "49344234422582",
"AFC-FULLYARD-AFS-FULLYARD-6-OI-FT-EXTRA-FEET" : "49344234455350",
"AFS-FULLYARD-6-OI-ST-350" : "48946872090934",
"AFS-FULLYARD-6-OI-ST-300" : "48946872418614",
"AFS-FULLYARD-6-OI-ST-200" : "48946872484150",
"AFS-FULLYARD-6-OI-ST-100" : "48946872582454",
"AFS-FULLYARD-6-OI-ST-75" : "48946872680758",
"AFS-FULLYARD-6-OI-ST-50" : "48946872942902",
"AFS-FULLYARD-5-OI-ST-350" : "48946873041206",
"AFS-FULLYARD-5-OI-ST-300" : "48946873237814",
"AFS-FULLYARD-5-OI-ST-200" : "48946873499958",
"AFS-FULLYARD-5-OI-ST-100" : "48946873827638",
"AFS-FULLYARD-5-OI-ST-75" : "48946873925942",
"AFS-FULLYARD-5-OI-ST-50" : "48946874057014",
"AFS-FULLYARD-6-OI-FT-350" : "48946874581302",
"AFS-FULLYARD-6-OI-FT-300" : "48946874777910",
"AFS-FULLYARD-6-OI-FT-200" : "48946875007286",
"AFS-FULLYARD-6-OI-FT-100" : "48946875236662",
"AFS-FULLYARD-6-OI-FT-75" : "48946875760950",
"AFS-FULLYARD-6-OI-FT-50" : "48946876219702",
"AFS-FULLYARD-5-OI-FT-350" : "48946876547382",
"AFS-FULLYARD-5-OI-FT-300" : "48946876776758",
"AFS-FULLYARD-5-OI-FT-200" : "48946877399350",
"AFS-FULLYARD-5-OI-FT-100" : "48946877858102",
"AFS-FULLYARD-5-OI-FT-75" : "48946878054710",
"AFS-FULLYARD-5-OI-FT-50" : "48946878382390",
"AFS-FULLYARD-4-OI-FT-350" : "48946878710070",
"AFS-FULLYARD-4-OI-FT-300" : "48946879070518",
"AFS-FULLYARD-4-OI-FT-200" : "48946879594806",
"AFS-FULLYARD-4-OI-FT-100" : "48946879955254",
"AFS-FULLYARD-4-OI-FT-75" : "48946880282934",
"AFS-FULLYARD-4-OI-FT-50" : "48946880872758",
"AFS-FULLYARD-5-OI-ST-250" : "48946881036598",
"AFS-FULLYARD-5-OI-ST-150" : "48946881200438",
"AFS-FULLYARD-6-OI-ST-250" : "48946881298742",
"AFS-FULLYARD-6-OI-ST-150" : "48946881790262",
"AFS-FULLYARD-6-OI-FT-250" : "48946882052406",
"AFS-FULLYARD-5-OI-FT-250" : "48946882543926",
"AFS-FULLYARD-4-OI-FT-250" : "48946882773302",
"AFS-FULLYARD-6-OI-FT-150" : "48946883133750",
"AFS-FULLYARD-5-OI-FT-150" : "48946883428662",
"AFS-FULLYARD-4-OI-FT-150" : "48946884510006",
"8FW100" : "48946884641078",
"8BFUNIVER" : "50860369215798",
"8BFUNIVER-PPB" : "50860369281334",
"50382" : "50860368757046",
"50382-PPB" : "50860368789814",
"8BFSWIVEL" : "50860368462134",
"8BFSWIVEL-PPB" : "50860368494902",
"816-811" : "48946885984566",
"816-815" : "48946886279478",
"816-809" : "50860367774006",
"816-809-PPB" : "50860367839542",
"8AB508" : "50860367151414",
"8AB508-PPB" : "50860367184182",
"8AF5X94ST" : "50860366659894",
"8AF5X94ST-PPB" : "50860366725430",
"8AF6X94ST" : "50860366364982",
"8AF6X94ST-PPB" : "50860366397750",
"8FS100" : "48946887426358",
"8W1FB1B" : "50860366135606",
"8W1FB1B-PPB" : "50860366168374",
"50139" : "50860365906230",
"50139-PPB" : "50860365938998",
"50165" : "50860365119798",
"50165-PPB" : "50860365185334",
"50149" : "50860364169526",
"50149-PPB" : "50860364267830",
"8BFLINE00" : "50860363678006",
"8BFLINE00-PPB" : "50860363743542",
"8FG100F" : "48946892669238",
"8HB370" : "48946892800310",
"8HB358" : "48946893259062",
"8HB346" : "48946894143798",
"8HB246" : "48946894340406",
"50383" : "50860363022646",
"50383-PPB" : "50860363055414",
"50384" : "50860362858806",
"50384-PPB" : "50860362891574",
"CUSTOMGATE16-12" : "48946895094070",
"CUSTOMGATE5-4" : "48946895356214",
"8AF6X94FT" : "50860361187638",
"8AF6X94FT-PPB" : "50860361220406",
"8AF5X94FT" : "50860360728886",
"8AF5X94FT-PPB" : "50860360761654",
"8AF4X94FT" : "50860360335670",
"8AF4X94FT-PPB" : "50860360368438",
"8BFFLUSH0" : "50860359778614",
"8BFFLUSH0-PPB" : "50860359811382",
"8AB103" : "48946898895158",
"8FN100F" : "48946899190070",
"8FN100" : "48946899550518",
"818-118-AL" : "48946905415990",
"8GATE4X6CD" : "48946906628406",
"8GATE4X6MD" : "48946907152694",
"8GATE4X5CD" : "48946907775286",
"8GATE4X5MD" : "48946908102966",
"8GATE4X4CD" : "48946908889398",
"8GATE4X4MD" : "48946909380918",
"20091" : "48946919473462",
"OIST-SS-6X6" : "48946919899446",
"OIST-DD-6X6" : "48946920325430",
"OIFT-SS-6X6" : "48946920390966",
"OIFT-DD-6X6" : "48946920685878",
"OIST-SS-6X5" : "48946920816950",
"OIST-DD-6X5" : "48946921275702",
"OIFT-SS-6X5" : "48946921341238",
"OIFT-DD-6X5" : "48946921636150",
"OIST-SS-6X4" : "48946921963830",
"OIST-DD-6X4" : "48946922094902",
"OIFT-SS-6X4" : "48946922160438",
"OIFT-DD-6X4" : "48946922455350",
"OIST-SS-5X6" : "48946928320822",
"OIFT-SS-5X6" : "48946928419126",
"OIST-SS-5X5" : "48946928582966",
"OIFT-SS-5X5" : "48946928746806",
"OIST-SS-5X4" : "48946929172790",
"OIFT-SS-5X4" : "48946929238326",
"20090" : "48946936217910",
"10858" : "48946936348982",
"AFS-ALP-58-2.5-125" : "48946937332022",
"AFS-ALP-58-2.5-075" : "48946937397558",
"AFS-ALP-58-2-125" : "48946937528630",
"AFS-ALP-58-2-093" : "48946937626934",
"AFS-ALP-58-2-062" : "48946937921846",
"8AB301" : "48946938216758",
"AFS-SB-3CHST60" : "48946938282294",
"AFS-SA-3CHST60" : "48946938839350",
"AFS-SBSSG-NAR-4'-ST60NM" : "48946939199798",
"AFS-SASSG-NAR-4'-ST60NM" : "48946939265334",
"8GATE4X6C" : "48946942443830",
"8GATE4X6M" : "48946943394102",
"8GATE4X5C" : "48946943787318",
"8GATE4X5M" : "48946944377142",
"8GATE4X4C" : "48946944999734",
"8GATE4X4M" : "48946945753398",
"8HB316" : "51275591221558",
"8HB316-PPB" : "51275591254326",
"OIST-SS-3X6" : "48946950406454",
"OIFT-SS-3X6" : "48946950701366",
"OIST-SS-3X5" : "48946950766902",
"OIFT-SS-3X5" : "48946950865206",
"OIST-SS-3X4" : "48946951127350",
"OIFT-SS-3X4" : "48946951455030",
"8PB30120" : "48946956763446",
"8HB412" : "51275591287094",
"50195" : "50860359156022",
"50195-PPB" : "50860359221558",
"8W125P96" : "50860358369590",
"8W125P96-PPB" : "50860358402358",
"8W125P72" : "50860357714230",
"8W125P72-PPB" : "50860357779766",
"8HB413" : "51275591319862",
"8HB413-PPB" : "51275591352630",
"8HB411" : "51275591385398",
"8HB411-PPB" : "51275591418166",
"8AB507" : "48946965774646",
"1762-White" : "48946966364470",
"8W12P93" : "50860357288246",
"8W12P93-PPB" : "50860357321014",
"8W12P81" : "50860357124406",
"8W12P81-PPB" : "50860357157174",
"8W12P69" : "50860356796726",
"8W12P69-PPB" : "50860356862262",
"8HB403" : "51275591450934",
"8HB403-PPB" : "51275591483702",
"8HB420" : "51275591516470",
"8HB420-PPB" : "51275591549238",
"8HB402" : "51275591614774",
"8HB402-PPB" : "51275591647542",
"8AB506" : "50860355977526",
"8AB506-PPB" : "50860356010294",
"8HB416" : "51275591680310",
"8HB416-PPB" : "51275591713078",
"OIST-DD-12X6" : "48946973770038",
"OIFT-DD-12X6" : "48946973868342",
"OIST-DD-12X5" : "48946974294326",
"OIFT-DD-12X5" : "48946974392630",
"OIST-DD-12X4" : "48946974490934",
"OIFT-DD-12X4" : "48946974785846",
"OIST-DD-10X6" : "48946977407286",
"OIFT-DD-10X6" : "48946977472822",
"OIST-DD-10X5" : "48946977898806",
"OIFT-DD-10X5" : "48946977997110",
"OIST-DD-10X4" : "48946978881846",
"OIFT-DD-10X4" : "48946985271606",
"8AB499P" : "48947000475958",
"8HB311" : "48947000607030",
"8HB414" : "48947001065782",
"835-114-6" : "48947001131318",
"8HB301" : "51275591778614",
"8HB301-PPB" : "51275591811382",
"8HB401" : "51275591876918",
"8HB401-PPB" : "51275591909686",
"8HB404" : "51275591942454",
"8HB404-PPB" : "51275591975222",
"8AF4X94FT-PPF" : "49333339521334",
"8AF5X94FT-PPF" : "49333393981750",
"8AF6X94FT-PPF" : "49333420065078",
"8AF6X94ST-PPF" : "49333434908982",
"8AF5X94ST-PPF" : "49333443789110",
"8AF4X94PP" : "50860370657590",
"8AF4X94PP-PPB" : "50860370723126",
"8AF6X94PP" : "50860369674550",
"8AF6X94PP-PPB" : "50860369707318",
"8AF4X94PP-PPF" : "49693762191670",
"8AF6X94PP-PPF" : "49693924557110",
"9AF48X72FT" : "51446384001334",
"9AF48X72FT-PPB" : "51446384034102",
"9AF72X72FT" : "51446408020278",
"9AF72X72FT-PPB" : "51446408053046",
"9AF2X72LINE" : "51446582509878",
"9AF2X72LINE-PPB" : "51446582542646",
"9AF2X72CORNER" : "51446584246582",
"9AF2X72CORNER-PPB" : "51446584279350",
"9AF2X72END" : "51446598009142",
"9AF2X72END-PPB" : "51446598041910",
"9AF25X72END" : "51446599123254",
"9AF25X72END-PPB" : "51446599156022",
"9AF2X96LINE" : "51446602367286",
"9AF2X96LINE-PPB" : "51446602400054",
"9AF2X96CORNER" : "51446603350326",
"9AF2X96CORNER-PPB" : "51446603383094",
"9AF2X96END" : "51446606135606",
"9AF2X96END-PPB" : "51446606168374",
"9AF25X96END" : "51446609346870",
"9AF25X96END-PPB" : "51446609379638",
"9AF4X4GATE" : "51446675964214",
"9AF4X4GATE-PPB" : "51446675996982",
"9AF4X5GATE" : "51446678847798",
"9AF4X5GATE-PPB" : "51446678880566",
"9AF6X4GATE" : "51446679732534",
"9AF6X4GATE-PPB" : "51446679765302",
"9AF6X5GATE" : "51446680256822",
"9AF6X5GATE-PPB" : "51446680289590",
"9AF506" : "51449305891126",
"9AF506-PPB" : "51449305923894",
"9AF507" : "51449313165622",
"9AF507-PPB" : "51449313198390",
"9AF48X72FT-PPF" : "51489660272950",
"9AF72X72FT-PPF" : "51489708704054",
"AFC-FULLYARD-4-BOA-FT-100" : "51521900740918",
"AFC-FULLYARD-4-BOA-FT-75" : "51521900773686",
"AFC-FULLYARD-4-BOA-FT-150" : "51521900806454",
"AFC-FULLYARD-4-BOA-FT-200" : "51521900871990",
"AFC-FULLYARD-4-BOA-FT-250" : "51521901035830",
"AFC-FULLYARD-4-BOA-FT-300" : "51521901199670",
"AFC-FULLYARD-4-BOA-FT-350" : "51521901297974",
"AFC-FULLYARD-5-BOA-FT-50" : "51521901330742",
"AFC-FULLYARD-5-BOA-FT-75" : "51521901429046",
"AFC-FULLYARD-5-BOA-FT-100" : "51521901461814",
"AFC-FULLYARD-5-BOA-FT-150" : "51521901527350",
"AFC-FULLYARD-5-BOA-FT-200" : "51521901560118",
"AFC-FULLYARD-5-BOA-FT-250" : "51521901592886",
"AFC-FULLYARD-5-BOA-FT-300" : "51521901658422",
"AFC-FULLYARD-5-BOA-FT-350" : "51521901691190",
"AFC-FULLYARD-6-BOA-FT-50" : "51521902444854",
"AFC-FULLYARD-6-BOA-FT-75" : "51521902477622",
"AFC-FULLYARD-6-BOA-FT-100" : "51521902543158",
"AFC-FULLYARD-6-BOA-FT-150" : "51521902575926",
"AFC-FULLYARD-6-BOA-FT-200" : "51521902608694",
"AFC-FULLYARD-6-BOA-FT-250" : "51521902805302",
"AFC-FULLYARD-6-BOA-FT-300" : "51521903100214",
"AFC-FULLYARD-6-BOA-FT-350" : "51521903460662",
"AFC-FULLYARD-4-BOA-FT-50" : "51630254063926",
"9AF25X84END" : "52479607537974",
"9AF25X84END-PPB" : "52479607570742",
"9AF2X84END" : "52479607767350",
"9AF2X84END-PPB" : "52479607800118",
"9AF2X84CORNER" : "52479607996726",
"9AF2X84CORNER-PPB" : "52479608029494",
"9AF2X84LINE" : "52479608226102",
"9AF2X84LINE-PPB" : "52479608291638",
"9AF60X72FT" : "52746509320502",
"9AF60X72FT-PPB" : "52746509353270",
"9AF5X4GATE" : "52746509517110",
"9AF5X4GATE-PPB" : "52746509549878",
"9AF5X5GATE" : "52746509582646",
"9AF5X5GATE-PPB" : "52746509615414",
"10840" : "53733670289718",
"10840-PPB" : "53733670322486",
"10841" : "53733670355254",
"10841-PPB" : "53733670388022",
"8HB415" : "53733670584630",
"1743-White" : "53733679661366",
"1743-Black" : "53733679694134",
"1743-TBlack" : "53733679726902",
"1740-White" : "53733679759670",
"1740-Black" : "53733679792438",
"1740-TBlack" : "53733679825206",
"1744-White" : "53733679890742",
"1744-Black" : "53733679923510",
"1744-TBlack" : "53733679956278",
"5559WHITE" : "53733679989046",
"5559BLACK" : "53733680021814",
"55595COPPER" : "53733680054582",
"1775-White" : "53733680087350",
"1775-Black" : "53733680120118",
"1775-TBlack" : "53733680152886",
"1745-White" : "53733680251190",
"1745-Black" : "53733680283958",
"1745-TBlack" : "53733680316726",
"1749-White" : "53733680382262",
"1749-Black" : "53733680415030",
"1749-TBlack" : "53733680447798",
"1747-White" : "53733680480566",
"1747-Black" : "53733680513334",
"1747-TBlack" : "53733680546102",
"1750-White" : "53733680578870",
"1750-Black" : "53733680611638",
"1750-TBlack" : "53733680644406",
"1765-White" : "53733680677174",
"1765-Black" : "53733680709942",
"1765-TBlack" : "53733680742710",
"1746-White" : "53733680775478",
"1746-Black" : "53733680808246",
"1746-TBlack" : "53733680841014",
"1764-White" : "53733680906550",
"1764-Black" : "53733680939318",
"1764-TBlack" : "53733680972086",
"1763-White" : "53733681070390",
"1763-Black" : "53733681103158",
"1763-TBlack" : "53733681135926",
"1751-White" : "53733681168694",
"1751-Black" : "53733681201462",
"1751-TBlack" : "53733681234230",
"1748-White" : "53733681266998",
"1748-Black" : "53733681299766",
"1748-TBlack" : "53733681332534",
"1778-White" : "53733681365302",
"1778-Black" : "53733681398070",
"17778-TBlack" : "53733681430838",
"1776-White" : "53733681463606",
"1776-Black" : "53733681496374",
"1776-TBlack" : "53733681529142",
"1742-White" : "53733682774326",
"8P3028080" : "53733722620214",
"8P3028080-PPB" : "53733792743734",
"8P3028800" : "53733722685750",
"8P3028800-PPB" : "53733722718518",
"AFS-FULLYARD-4-OI-FTPP-50" : "53733722751286"
    }
]